const dispatch = {
  dispatch$setFocus: (payload) => ({
    type: 'SET_FOCUS',
    payload: payload
  })
};

export default dispatch;
